function accessToken(session) {
  const token = session && session.access_token;
  if (typeof token !== 'string') return '';
  return token.trim();
}

function hasAccessToken(session) {
  return accessToken(session).length > 0;
}

module.exports = {
  accessToken,
  hasAccessToken,
};
